import { useContext, useMemo } from "react";
import { AppContext } from "../App";
import logo from "../assets/logo.png";

const primaryLinks = [
  { label: "Home", item: "home" },
  { label: "Projects", item: "projects" },
  { label: "Services", item: "services" },
];

const aboutLinks = [
  { label: "Overview", item: "about_us", subItem: "overview" },
  { label: "Team", item: "about_us", subItem: "team" },
  { label: "Policies", item: "about_us", subItem: "policies" },
];

export default function TopBar() {
  const appContext = useContext(AppContext);

  const activeItem = useMemo(() => {
    if (!appContext.navItem || appContext.navItem === "home") {
      return "home";
    }

    if (appContext.navItem === "about_us") {
      return "about_us";
    }

    if (appContext.navItem === "contact_us") {
      return "contact_us";
    }

    if (appContext.navItem === "projects") {
      return "projects";
    }

    if (appContext.navItem === "services") {
      return "services";
    }

    return "";
  }, [appContext.navItem]);

  function goTo(nav) {
    appContext.navTo(typeof nav === "string" ? { item: nav } : nav);
  }

  return (
    <header
      className="TopBar"
      data-scrolled={appContext.isScrolled}
    >
      <div className="body">
        <div className="tgm-orion-topbar-shell">
          <div className="container">
            <div className="tgm-orion-topbar-row">
              <button
                type="button"
                className="tgm-orion-brand"
                  onClick={() => goTo("home")}
                aria-label="Go to home"
              >
                <span className="tgm-orion-brand-mark">
                  <img src={logo} alt="SMART TGM logo" />
                </span>
              </button>

              <nav className="tgm-orion-nav" aria-label="Primary">
                <button
                  type="button"
                  className="tgm-orion-nav-link font-semi-bold"
                  data-active={activeItem === "home"}
                  onClick={() => goTo("home")}
                >
                  <span>Home</span>
                </button>

                <div className="tgm-orion-nav-dropdown">
                  <button
                    type="button"
                    className="tgm-orion-nav-link font-semi-bold"
                    data-active={activeItem === "about_us"}
                    onClick={() =>
                      goTo({ item: "about_us", subItem: "overview" })
                    }
                  >
                    <span>About</span>
                  </button>
                  <div className="tgm-orion-dropdown-menu">
                    {aboutLinks.map((link) => (
                      <button
                        key={link.subItem}
                        type="button"
                        onClick={() => goTo(link)}
                      >
                        {link.label}
                      </button>
                    ))}
                  </div>
                </div>

                {primaryLinks.slice(1).map((link) => {
                  return (
                    <button
                      key={link.item}
                      type="button"
                      className="tgm-orion-nav-link font-semi-bold"
                      data-active={activeItem === link.item}
                      onClick={() => goTo(link.item)}
                    >
                      <span>{link.label}</span>
                    </button>
                  );
                })}
              </nav>

              <button
                type="button"
                className="tgm-orion-topbar-cta font-semi-bold"
                data-active={activeItem === "contact_us"}
                onClick={() => goTo("contact_us")}
              >
                Contact
              </button>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}
